import React from 'react';
import { Outlet } from 'react-router-dom';
import AuthHeader from '../../shared-component/auth-header/AuthHeader';

const AuthLayoutComponent = () => {

    return (
        <React.Fragment>
            <AuthHeader />
            <Outlet />
        </React.Fragment>
    )
}

export default AuthLayoutComponent;